import { Injectable } from '@angular/core';
import { readOnlyEntity } from '@myia/ngx-core';
import { ReduxStore } from '@myia/ngx-redux';
import { IStatusBarMessage } from '../entities/statusBarMessage.interface';
import { addStatusBarMessage, clearAllStatusBarMessages, removeStatusBarMessage, showStatusBarBusyLine, updateStatusBarMessage } from '../redux/statusBarActions';

const defaultMessageOptions = {
    centered: false,
    key: null
};

@Injectable({ providedIn: 'root' })
export class StatusBarManager {
    private _msgCounter: number = 0;

    constructor(private _store: ReduxStore) {
    }

    showMessage(text: string, options?: {key?: string, centered?: boolean}): IStatusBarMessage {
        const msgOptions = {...defaultMessageOptions, ...options};
        const msg = readOnlyEntity<IStatusBarMessage>({messageKey: msgOptions.key || this.getNewMsgKey(), messageText: text, centered: msgOptions.centered});
        this._store.dispatch(addStatusBarMessage(msg));
        return msg;
    }

    updateMessage(message: IStatusBarMessage) {
        this._store.dispatch(updateStatusBarMessage(message));
    }

    hideMessage(message: IStatusBarMessage | undefined) {
        if (message) {
            this._store.dispatch(removeStatusBarMessage(message.messageKey));
        }
    }

    clearAllMessages() {
        this._store.dispatch(clearAllStatusBarMessages());
    }


    showBusyLine(show: boolean, key: string) {
        this._store.dispatch(showStatusBarBusyLine(show, key));
    }

    private getNewMsgKey(): string {
        this._msgCounter++;
        return `msg` + this._msgCounter;
    }
}
